// Module
var code = "<div class=\"flow-status-progress--container\" title=\"{{$ctrl.progressAlt}}\"> <div class=\"flow-status-progress--bar\" flow-status-bar=\"$ctrl.progress\"></div> </div> ";
// Exports
export default code;